import amplitude from 'amplitude-js'
import { Config, IS_PRO } from './config'

interface IStatis {
  Init: () => any
  Login: (...args: any[]) => any
  Track: (eventName: string, eventParams: any) => any
}

interface IUserProperties {
  email?: string
  memberType?: string
}

class Statis implements IStatis {
  //   private instance: amplitude.AmplitudeClient;

  // 公共事件属性
  private publicEventParams = Object.create(null)

  //   constructor() {
  //     this.instance = amplitude.getInstance();
  //   }

  /**
   * 设置公共事件属性
   * @param eventParams 时间属性
   */
  public setPublicEventParams(eventParams: Record<string, any>) {
    this.publicEventParams = eventParams
  }

  /**
   * 合并公共事件
   * @param eventParams 事件参数
   */
  private assignEventParams(eventParams?: Record<string, any>) {
    return Object.assign({}, this.publicEventParams, eventParams)
  }

  // 实例
  public get instance() {
    return amplitude.getInstance()
  }

  /**
   * 初始化
   */
  public Init() {
    if (IS_PRO) {
      this.instance.init(Config.amplitude.API_KEY as string, void 0, {
        includeGclid: true,
        includeReferrer: true,
        includeUtm: true,
      })
    }
  }

  /**
   * 用户登录绑定
   * @param userId 用户ID
   * @param userProperties 用户属性
   */
  public Login(userId: string, userProperties?: IUserProperties) {
    if (IS_PRO) {
      this.instance.setUserId(userId)
      if (userProperties) {
        this.setUserProperties(userProperties)
      }
    }
  }

  /**
   * 采集事件
   * @param eventName 事件名称
   * @param eventParams 事件参数
   */
  public Track(eventName: string, eventParams?: Record<string, any>): Promise<any> {
    const params = this.assignEventParams(eventParams)
    return new Promise((re) => {
      if (IS_PRO) {
        this.instance.logEvent(eventName, params, re)
      }
    })
  }

  /**
   * 设置用户属性
   * @param userProperties 用户属性
   */
  public setUserProperties(userProperties: IUserProperties) {
    const { email, memberType } = userProperties
    this.instance.setUserProperties({
      email,
      memberType,
    })
  }
}

const sa = new Statis()

export default sa
